export default "__VITE_ASSET__CGSQ6cFr__"